<article class="block-question container section-outset-y">
  <div class="row align-items-center">
    <div class="col-md-4 px-5 px-md-0">
      <fstr-image
        [width]="515"
        [height]="515"
        [alt]="block.image.alt || block.title || 'Afbeelding'"
        [imageSizes]="[250, 550, 800, 1000]"
        *ngIf="block.image"
        [image]="block.image"
      ></fstr-image>
    </div>
    <div class="col-md-7 offset-md-1 block-question__main">
      <span class="block-question__label align-items-center d-flex" *ngIf="block.label">{{ block.label }}</span>
      <h3 class="mb-0 mt-3 font-display fw-bold" *ngIf="block.subtitle">{{ block.subtitle }}</h3>
      <h3 *ngIf="block.title">
        <ngx-dynamic-hooks
          [options]="{ sanitize: false, updateOnPushOnly: true }"
          [content]="block.title | highlight : 'text-primary-gradient'"
        ></ngx-dynamic-hooks>
      </h3>

      <div class="d-flex flex-gap-3">
        <fstr-link *ngIf="block.button" cssClasses="button button button--primary-gradient has--dot" [button]="block.button!">
          <ng-container *ngIf="!block.button?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
        </fstr-link>
        <fstr-link
          *ngIf="block.secondaryButton"
          cssClasses="button button-outline button--primary has--dot"
          [button]="block.secondaryButton!"
        >
          <ng-container *ngIf="!block.secondaryButton?.text">{{ 'lees-meer' | fromDictionary }}</ng-container>
        </fstr-link>
      </div>
    </div>
  </div>
</article>
